import { Modal, ModalFooter, ModalBody, ModalHeader } from 'ui/modal';
import { PrimaryButton } from 'ui/button';
import {
  TEST_IDS,
  CREATE_MODAL_CONFIRMATION_HEADER,
  CREATE_MODAL_CONFIRMATION_BODY_TEXT,
  CREATE_MODAL_CONFIRMATION_CONFIRM_BTN_TEXT,
  CREATE_MODAL_CONFIRMATION_BODY_FOLLOWING_TEXT,
} from 'modules/predictiveGoals/constants';
import { PredictiveAudienceGoal } from '../../types';
import { ModalText } from '../Styled';

export type ConfirmGoalCreationModalProps = {
  goal?: PredictiveAudienceGoal;
  onClose: () => void;
  onConfirmClick: () => void;
  isModalOpen: boolean;
};

export const ConfirmGoalCreationModal = ({
  isModalOpen,
  onClose,
  onConfirmClick,
}: ConfirmGoalCreationModalProps) => {
  return (
    <Modal
      id={TEST_IDS.ConfirmGoalCreationModal}
      isModalOpen={isModalOpen}
      onClose={onClose}
      size="small"
    >
      <ModalHeader>{CREATE_MODAL_CONFIRMATION_HEADER}</ModalHeader>
      <ModalBody>
        <ModalText>{CREATE_MODAL_CONFIRMATION_BODY_TEXT}</ModalText>
        <ModalText>{CREATE_MODAL_CONFIRMATION_BODY_FOLLOWING_TEXT}</ModalText>
      </ModalBody>
      <ModalFooter>
        <PrimaryButton onClick={onConfirmClick}>
          {CREATE_MODAL_CONFIRMATION_CONFIRM_BTN_TEXT}
        </PrimaryButton>
      </ModalFooter>
    </Modal>
  );
};
